module.exports = __webpack_public_path__ + "img/i_shijian.26306583.svg";